import useLanguageRegionCode from 'hooks/useLanguageRegionCode';
import { FormattedMessage } from '@alltrails/shared/react-intl';
import MarketingModal from './MarketingModal';
import navigatorW622Src from './navigator-w622.jpg';
import navigatorW864Src from './navigator-w864.jpg';
import navigatorW864AvifSrc from './navigator-w864.avif';
import navigatorW622AvifSrc from './navigator-w622.avif';
import * as styles from './styles/styles.module.scss';
import { MEDIA_QUERY_SMALL_DOWN } from '../../utils/constants/breakpoints';

function NavigatorModal() {
  const languageRegionCode = useLanguageRegionCode();

  const Picture = (
    <picture>
      <source media={MEDIA_QUERY_SMALL_DOWN} srcSet={navigatorW622AvifSrc} type="image/avif" />
      <source media={MEDIA_QUERY_SMALL_DOWN} srcSet={navigatorW622Src} />
      <source srcSet={navigatorW864AvifSrc} type="image/avif" />
      <img className={styles.img} src={navigatorW864Src} />
    </picture>
  );

  return (
    <MarketingModal
      headerText={
        languageRegionCode === 'en-US' ? (
          <FormattedMessage defaultMessage="Download the AllTrails app to use Navigator" />
        ) : (
          <FormattedMessage defaultMessage="Navigator is an app-only feature" />
        )
      }
      instructionsText={
        <FormattedMessage defaultMessage="Navigator is only for iOS or Android. Enter your US mobile number to text yourself a download link." />
      }
      picture={Picture}
    />
  );
}

export default NavigatorModal;
